import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EditUserPassword } from '../../redux/Slices/UserSlice'
import notify from '../UseNotification'
import { useNavigate } from 'react-router-dom'

const UseEditUserPassword = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [EditPasswordLoading, setEditPasswordLoading] = useState(true)
    const [currentPassword, setCurrentPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmNewPassword, setConfirmNewPassword] = useState("")
    const [isChangePasswordPress, setIsChangePasswordPress] = useState(false)
    const [isChangePasswordValidate, setIsChangePasswordValidate] = useState(false)
    const { editUserPassword } = useSelector(state => state.UserReducer)

    // handle current password
    const HandleChangeCurrentPassword = (e) => {
        setCurrentPassword(e.target.value)
    }

    // handle new password
    const HandleChangeNewPassword = (e) => {
        setNewPassword(e.target.value)
    }

    // handle Confirm password
    const HandleChangeConfirmPassword = (e) => {
        setConfirmNewPassword(e.target.value)
    }

    // handle the validate current password
    const ValidateCurrentPassword = (e) => {
        if (e.target.value === "") {
            notify("Please, enter current Password", "error")
        }
    }

    // handle the validate new password
    const ValidateNewPassword = (e) => {
        if (e.target.value === "") {
            notify("Please, enter New Password", "error")
        }
        if (newPassword != confirmNewPassword) {
            notify("confirm password not equal", "error")
        }
    }

    // handle the Validate Confirm Password
    const ValidateConfirmPassword = (e) => {
        if (e.target.value === "") {
            notify("Please, enter confirm Password", "error")
        }
        if (newPassword != confirmNewPassword) {
            notify("confirm password not equal", "error")
        }
    }

    // validate to disbale the save button
    useEffect(() => {
        if (currentPassword && newPassword && confirmNewPassword && newPassword === confirmNewPassword) {
            setIsChangePasswordValidate(true);
        } else {
            setIsChangePasswordValidate(false);
        }
    }, [currentPassword, newPassword, confirmNewPassword])
    
    // handle edit password
    const HandleEditUserPassword = async () => {
        setIsChangePasswordPress(true)
        setEditPasswordLoading(true)
        await dispatch(EditUserPassword({
            currentPassword: currentPassword,
            password: newPassword,
            passwordConfirm: confirmNewPassword
        }))
        setEditPasswordLoading(false)
    }

    useEffect(() => {
        if (EditPasswordLoading === false) {
            if (editUserPassword && editUserPassword.status === 200) {
                notify("Password Changed", "success")
                localStorage.removeItem("token")
                navigate("/login")
            } else {
                editUserPassword.response.data.errors.map((item) => { return (notify(item.msg, "error")) })
            }
        }
    }, [EditPasswordLoading])

    return [isChangePasswordPress, isChangePasswordValidate, EditPasswordLoading, ValidateCurrentPassword, ValidateNewPassword, ValidateConfirmPassword, currentPassword, newPassword, confirmNewPassword, HandleChangeCurrentPassword, HandleChangeNewPassword, HandleChangeConfirmPassword, HandleEditUserPassword
    ]
}

export default UseEditUserPassword
